<div class="broker-dashboard-shell">
  <!-- Topbar -->
  <header class="broker-header">
    <div class="brand">
      <span class="material-symbols-outlined brand-icon">handshake</span>
      <div>
        <h2 class="brand-title">Weddingly Broker Portal</h2>
        <span class="agency-tag">{{ broker?.agency_name || broker?.name }}</span>
      </div>
    </div>

    <div class="header-actions">
      <!-- Notification Bell & Dropdown -->
      <div class="notification-bell-wrap">
        <button class="btn-bell" (click)="toggleNotifications()" [class.has-unread]="newLeadsCount > 0" title="Broker Notifications">
          <span class="material-symbols-outlined bell-icon">notifications</span>
          <span class="bell-badge" *ngIf="newLeadsCount > 0">{{ newLeadsCount }}</span>
          <span class="pulse-ring" *ngIf="newLeadsCount > 0"></span>
        </button>

        <div class="notifications-dropdown" *ngIf="showNotificationsDropdown">
          <div class="dropdown-header">
            <div class="header-title">
              <span class="material-symbols-outlined">notifications_active</span>
              <h4>Broker Notifications</h4>
            </div>
            <span class="unread-count-pill" *ngIf="newLeadsCount > 0">{{ newLeadsCount }} New</span>
          </div>

          <div class="dropdown-body">
            <div class="empty-notif" *ngIf="leads.length === 0">
              <span class="material-symbols-outlined">notifications_off</span>
              <p>No notifications yet. When members show interest in your candidates, instant alerts will appear here!</p>
            </div>

            <div class="notif-list" *ngIf="leads.length > 0">
              <div class="notif-item" *ngFor="let lead of leads" [class.unread-item]="lead.status === 'New'" (click)="viewLeadFromNotification(lead)">
                <div class="notif-avatar">
                  <img [src]="lead.interested_user?.profile_photo || 'assets/default-avatar.png'" onerror="this.src='assets/default-avatar.png'">
                  <span class="notif-status-dot" *ngIf="lead.status === 'New'"></span>
                </div>
                <div class="notif-content">
                  <p class="notif-text">
                    <strong>{{ lead.interested_user?.name || 'A Member' }}</strong> sent a matchmaking request to your candidate <strong>{{ lead.candidate?.name || 'Candidate' }}</strong>!
                  </p>
                  <div class="notif-meta">
                    <span class="time"><span class="material-symbols-outlined" style="font-size:12px;">schedule</span> {{ lead.created_at | date:'shortTime' }}</span>
                    <span class="status-tag" [class]="'tag-' + lead.status?.toLowerCase()">{{ lead.status }}</span>
                  </div>
                </div>
                <span class="material-symbols-outlined arrow-icon">chevron_right</span>
              </div>
            </div>
          </div>

          <div class="dropdown-footer">
            <button class="btn-view-all" (click)="activeTab = 'leads'; showNotificationsDropdown = false;">
              View All in Leads CRM <span class="material-symbols-outlined" style="font-size:14px;">arrow_forward</span>
            </button>
          </div>
        </div>
      </div>

      <div class="broker-meta">
        <span class="name-text">{{ broker?.name }}</span>
        <span class="rate-badge">{{ broker?.commission_rate || 15 }}% Commission</span>
      </div>
      <button class="btn-logout" (click)="logout()" title="Logout">
        <span class="material-symbols-outlined">logout</span>
      </button>
    </div>
  </header>

  <div class="dashboard-content">
    <div *ngIf="successMsg" class="alert-success">
      <span class="material-symbols-outlined">check_circle</span> {{ successMsg }}
    </div>

    <!-- Live Lead Alert Toast Banner -->
    <div class="live-lead-alert" *ngIf="newLeadsCount > 0 && !dismissLeadAlert && activeTab !== 'leads'">
      <div class="alert-icon-wrap">
        <span class="material-symbols-outlined bounce-icon">campaign</span>
        <span class="alert-ping"></span>
      </div>
      <div class="alert-msg">
        <h4>🎉 Instant Lead Alert: You have {{ newLeadsCount }} New Matchmaking Request{{ newLeadsCount > 1 ? 's' : '' }}!</h4>
        <p>Matrimony members have sent interest to your listed candidates. Click below to view inquiries and connect offline!</p>
      </div>
      <div class="alert-actions">
        <button class="btn-go-leads" (click)="activeTab = 'leads'; dismissLeadAlert = true;">Review Leads Now</button>
        <button class="btn-dismiss-alert" (click)="dismissLeadAlert = true" title="Dismiss"><span class="material-symbols-outlined">close</span></button>
      </div>
    </div>

    <!-- KPI Cards -->
    <div class="kpi-grid">
      <div class="kpi-card wallet-card">
        <div class="kpi-header">
          <span class="kpi-title">Wallet Balance</span>
          <span class="material-symbols-outlined kpi-icon">account_balance_wallet</span>
        </div>
        <div class="kpi-value">₹{{ broker?.stats?.wallet_balance || 0 }}</div>
        <div class="kpi-footer">
          <span>Available for withdrawal</span>
          <button class="btn-payout" *ngIf="(broker?.stats?.wallet_balance || 0) > 0" (click)="openPayoutModal()">
            Request Payout
          </button>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-title">Total Revenue Earned</span>
          <span class="material-symbols-outlined kpi-icon" style="color: #1e7e48; background: #eef9f2;">payments</span>
        </div>
        <div class="kpi-value">₹{{ broker?.stats?.total_earned || 0 }}</div>
        <div class="kpi-footer">Lifetime commission earnings</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-header">
          <span class="kpi-title">Candidates Uploaded</span>
          <span class="material-symbols-outlined kpi-icon" style="color: #2b6cb0; background: #ebf8ff;">group_add</span>
        </div>
        <div class="kpi-value">{{ candidates.length || broker?.stats?.total_candidates || 0 }}</div>
        <div class="kpi-footer">
          <span>Active bio-datas listed</span>
          <button class="btn-add-quick" (click)="openAddCandidateModal()">+ Upload New</button>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <div class="nav-tabs">
      <button class="tab-btn" [class.active]="activeTab === 'candidates'" (click)="activeTab = 'candidates'">
        <span class="material-symbols-outlined">badge</span> My Candidate Directory ({{ candidates.length }})
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'leads'" (click)="activeTab = 'leads'">
        <span class="material-symbols-outlined">connect_without_contact</span> Leads & Inquiries ({{ leads.length }})
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'plans'" (click)="activeTab = 'plans'">
        <span class="material-symbols-outlined">workspace_premium</span> Subscription Plans
        <span class="plan-tab-badge">{{ currentBrokerPlan || 'FREE_BROKER' }}</span>
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'commissions'" (click)="activeTab = 'commissions'">
        <span class="material-symbols-outlined">receipt_long</span> Commission Earnings Log
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'bank'" (click)="activeTab = 'bank'">
        <span class="material-symbols-outlined">account_balance</span> Bank & UPI Settings
      </button>
    </div>

    <!-- TAB 1: Candidate Directory -->
    <div *ngIf="activeTab === 'candidates'" class="tab-pane">
      <div class="pane-header">
        <div>
          <h3>Uploaded Candidate Profiles</h3>
          <p>These bio-datas are visible to Weddingly members. When someone upgrades to connect with them, you earn 15%!
          </p>
        </div>
        <button class="btn-add-primary" (click)="openAddCandidateModal()">
          <span class="material-symbols-outlined">person_add</span> Upload Candidate Bio-Data
        </button>
      </div>

      <div *ngIf="candidates.length === 0" class="empty-state">
        <span class="material-symbols-outlined">folder_open</span>
        <h4>No Candidates Uploaded Yet</h4>
        <p>Click "Upload Candidate Bio-Data" above to list grooms and brides without email verification hassle!</p>
      </div>

      <div *ngIf="candidates.length > 0" class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Candidate Name</th>
              <th>Gender & Age</th>
              <th>Religion / Caste</th>
              <th>Location & Contact</th>
              <th>Education & Profession</th>
              <th>Plan / Views</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of candidates">
              <td>
                <div class="profile-cell">
                  <a [routerLink]="['/profile-details', c._id]" target="_blank"
                    style="color: var(--color-primary, #B01E3E); text-decoration: none; font-weight: 700;">
                    {{ c.basic_info?.first_name }} {{ c.basic_info?.last_name }} <span class="material-symbols-outlined"
                      style="font-size: 14px; vertical-align: middle;">open_in_new</span>
                  </a>
                  <span class="profile-id">ID: {{ c._id | slice: -8 }}</span>
                </div>
              </td>
              <td>
                <strong>{{ c.basic_info?.gender }}</strong><br>
                <small style="color: #666;">{{ c.basic_info?.age || '21' }} yrs &bull; {{
                  c.personal_info?.marital_status || 'Never Married' }}</small>
              </td>
              <td>
                <strong>{{ c.religion_info?.religion_id?.religion_name || c.religion_info?.religion_id?.religion_nme ||
                  c.religion_info?.religion_id || 'Not Specified' }}</strong><br>
                <small style="color: #666;">{{ c.religion_info?.caste_id?.caste_name ||
                  c.religion_info?.caste_id?.caste_nme || c.religion_info?.caste_id || 'General' }}</small>
              </td>
              <td>
                <strong>{{ c.residing_location?.city_id?.city_name || c.residing_location?.city_id?.city_nme ||
                  c.residing_location?.city || 'City N/A' }}, {{ c.residing_location?.state_id?.state_name ||
                  c.residing_location?.state_id?.state_nme || c.residing_location?.state || 'State N/A' }}</strong><br>
                <small style="color: #444; font-weight: 500;">📞 {{ c.basic_info?.mobile || 'No Phone' }}</small>
              </td>
              <td>
                <strong>🎓 {{ c.professional_info?.education_detail || c.professional_info?.education_id?.education_name
                  || c.professional_info?.education_id?.education_nme || 'Edu N/A' }}</strong><br>
                <small style="color: #666;">💼 {{ c.professional_info?.occupation_id?.occupation_name ||
                  c.professional_info?.occupation_id?.occupation_nme || 'Occ N/A' }}{{ c.professional_info?.occupation_detail ? ' · ' + c.professional_info.occupation_detail : '' }}</small>
              </td>
              <td>
                <span class="plan-badge" [class]="c.current_plan">{{ c.current_plan || 'FREE' }}</span><br>
                <button class="btn-views-pill" (click)="openCandidateViewersModal(c)" title="See Who Viewed Profile & Contact Details">
                  <span class="material-symbols-outlined" style="font-size: 14px;">visibility</span>
                  {{ c.recent_profile_views?.length || c.profile_views_today || 0 }} Views ⭐
                </button>
              </td>
              <td>
                <span class="claim-badge" [class]="c.claim_status">{{ c.claim_status === 'claimed' ? 'Claimed by
                  Candidate' : 'Broker Managed' }}</span>
              </td>
              <td>
                <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                  <button *ngIf="c.claim_status !== 'claimed'" class="btn-claim-otp" (click)="openEditModal(c)"
                    title="Edit Full Bio-Data" style="background: #f0f4f8; color: #333; border: 1px solid #ccc;">
                    <span class="material-symbols-outlined" style="font-size: 16px;">edit</span> Edit
                  </button>
                  <button *ngIf="c.claim_status !== 'claimed'" class="btn-claim-otp" (click)="initiateClaim(c)"
                    title="Generate Handover OTP">
                    <span class="material-symbols-outlined" style="font-size: 16px;">key</span> Handover
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- TAB 2: Commission Earnings Log -->
    <div *ngIf="activeTab === 'commissions'" class="tab-pane">
      <div class="pane-header">
        <div>
          <h3>Commission History</h3>
          <p>Real-time audit log of all subscription revenue generated by your listed candidates.</p>
        </div>
      </div>

      <div *ngIf="commissions.length === 0" class="empty-state">
        <span class="material-symbols-outlined">history</span>
        <h4>No Commissions Earned Yet</h4>
        <p>When Weddingly members purchase Silver, Gold, or Platinum plans to connect with your candidates, your 15% cut
          will appear here.</p>
      </div>

      <div *ngIf="commissions.length > 0" class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Candidate Profile</th>
              <th>Subscriber User</th>
              <th>Plan Purchased</th>
              <th>Total Paid</th>
              <th>Your Commission (%)</th>
              <th>Earned Cut (₹)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of commissions">
              <td>{{ log.created_at | date:'mediumDate' }}</td>
              <td><strong>{{ log.profile_id?.basic_info?.first_name || 'Candidate' }}</strong></td>
              <td>{{ log.subscriber_id?.basic_info?.first_name || 'Member' }}</td>
              <td><span class="plan-badge" [class]="log.plan_code">{{ log.plan_code }}</span></td>
              <td>₹{{ log.amount_paid }}</td>
              <td>{{ log.commission_rate }}%</td>
              <td class="earned-cut">+₹{{ log.commission_amount }}</td>
              <td><span class="claim-badge claimed">Credited</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- TAB 3: Bank & UPI Settings -->
    <div *ngIf="activeTab === 'bank'" class="tab-pane">
      <div class="pane-header">
        <div>
          <h3>Payout Destination Settings</h3>
          <p>Configure where you want your wallet balance transferred when you request a payout.</p>
        </div>
      </div>

      <div class="form-card">
        <form (ngSubmit)="saveBankDetails()" class="bank-form">
          <div class="form-row">
            <div class="form-group">
              <label>Account Holder Name</label>
              <input type="text" [(ngModel)]="bankDetails.account_holder" name="holder"
                placeholder="Name as per bank account" class="form-input">
            </div>
            <div class="form-group">
              <label>Bank Account Number</label>
              <input type="text" [(ngModel)]="bankDetails.account_number" name="acc_no"
                placeholder="Enter bank account number" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>IFSC Code</label>
              <input type="text" [(ngModel)]="bankDetails.ifsc_code" name="ifsc" placeholder="e.g. SBIN0001234"
                class="form-input">
            </div>
            <div class="form-group">
              <label>UPI ID / VPA (Optional)</label>
              <input type="text" [(ngModel)]="bankDetails.upi_id" name="upi"
                placeholder="e.g. broker@okaxis or 9876543210@paytm" class="form-input">
            </div>
          </div>

          <button type="submit" class="btn-save-bank" [disabled]="savingBank">
            <span class="material-symbols-outlined spin" *ngIf="savingBank">progress_activity</span>
            <span>{{ savingBank ? 'Saving...' : 'Save Payout Settings' }}</span>
          </button>
        </form>
      </div>
    </div>

    <!-- TAB 4: Leads & Inquiries -->
    <div *ngIf="activeTab === 'leads'" class="tab-pane">
      <div class="leads-banner" *ngIf="!canViewContacts">
        <div class="banner-icon"><span class="material-symbols-outlined">lock_person</span></div>
        <div class="banner-text">
          <h4>Unlock Direct Contact Numbers & Emails</h4>
          <p>You are currently on the <strong>Free Broker</strong> plan. When Matrimony members send interest to your candidates, their contact details are locked. Upgrade to <strong>Basic or Pro Broker</strong> to instantly view phone numbers and connect offline!</p>
        </div>
        <button class="btn-banner-upgrade" (click)="activeTab = 'plans'">Upgrade Now</button>
      </div>

      <div class="leads-banner unlocked-banner" *ngIf="canViewContacts">
        <div class="banner-icon"><span class="material-symbols-outlined">verified_user</span></div>
        <div class="banner-text">
          <h4>Lead Contact Access Active</h4>
          <p>Your <strong>{{ currentBrokerPlan }}</strong> plan gives you direct access to interested members' mobile numbers and email addresses. Connect with them directly to finalize matchmaking offline!</p>
        </div>
      </div>

      <div class="empty-state" *ngIf="leads.length === 0 && !loadingLeads">
        <span class="material-symbols-outlined empty-icon">connect_without_contact</span>
        <h4>No Leads Yet</h4>
        <p>When users send interests to your listed bio-datas, their inquiries will appear here.</p>
      </div>

      <div class="leads-grid" *ngIf="leads.length > 0">
        <div class="lead-card" *ngFor="let lead of leads">
          <div class="lead-header">
            <span class="lead-date"><span class="material-symbols-outlined" style="font-size:14px;vertical-align:middle;">event</span> {{ lead.created_at | date:'mediumDate' }}</span>
            <span class="lead-status-badge" [ngClass]="'status-' + (lead.status | lowercase)">{{ lead.status }}</span>
          </div>
          
          <div class="lead-body">
            <div class="profile-col candidate-col">
              <span class="col-label">YOUR CANDIDATE</span>
              <div class="profile-info">
                <img [src]="lead.candidate?.profile_photo || 'assets/default-avatar.png'" class="avatar-sm" onerror="this.src='assets/default-avatar.png'">
                <div class="name-wrap">
                  <span class="name">{{ lead.candidate?.name }}</span>
                </div>
              </div>
            </div>

            <div class="match-arrow">
              <span class="material-symbols-outlined">favorite</span>
            </div>

            <div class="profile-col interested-col">
              <span class="col-label">INTERESTED MEMBER</span>
              <div class="profile-info">
                <img [src]="lead.interested_user?.profile_photo || 'assets/default-avatar.png'" class="avatar-sm" onerror="this.src='assets/default-avatar.png'">
                <div class="name-wrap">
                  <span class="name">{{ lead.interested_user?.name }}</span>
                  <span class="city" *ngIf="lead.interested_user?.contact_details?.city !== 'N/A'">📍 {{ lead.interested_user?.contact_details?.city }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="lead-contact-section">
            <div *ngIf="!canViewContacts" class="contact-locked-box">
              <span class="material-symbols-outlined lock-icon">lock</span>
              <div class="lock-text">
                <strong>Contact Details Hidden</strong>
                <span>Mobile: +91 ********* &nbsp;|&nbsp; Email: locked&#64;upgrade.plan</span>
              </div>
              <button class="btn-unlock-xs" (click)="activeTab = 'plans'">Unlock Contact</button>
            </div>

            <div *ngIf="canViewContacts" class="contact-unlocked-box">
              <div class="contact-item">
                <span class="material-symbols-outlined">call</span>
                <a [href]="'tel:' + lead.interested_user?.contact_details?.mobile"><strong>{{ lead.interested_user?.contact_details?.mobile }}</strong></a>
              </div>
              <div class="contact-item">
                <span class="material-symbols-outlined">mail</span>
                <a [href]="'mailto:' + lead.interested_user?.contact_details?.email">{{ lead.interested_user?.contact_details?.email }}</a>
              </div>
            </div>
          </div>

          <div class="lead-footer">
            <div class="status-action">
              <label>Update Status:</label>
              <select [ngModel]="lead.status" (ngModelChange)="onUpdateLeadStatus(lead, $event)" class="status-select">
                <option value="New">New Inquiry</option>
                <option value="Contacted">Contacted / In Talks</option>
                <option value="Closed">Closed / Matched</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TAB 5: Subscription Plans -->
    <div *ngIf="activeTab === 'plans'" class="tab-pane">
      <div class="plans-header">
        <h3>Supercharge Your Matchmaking Agency</h3>
        <p>Select a broker plan to unlock direct contact numbers, increase candidate upload quotas, and scale your matrimonial business.</p>
      </div>

      <div class="broker-plans-grid">
        <div class="broker-plan-card" *ngFor="let plan of brokerPlans" [ngClass]="{'current-plan-card': currentBrokerPlan === plan.plan_code}">
          <div class="plan-badge-top" *ngIf="currentBrokerPlan === plan.plan_code">ACTIVE PLAN</div>
          <div class="plan-title-area">
            <h4>{{ plan.display_name }}</h4>
            <p class="plan-tagline">{{ plan.tagline }}</p>
          </div>
          <div class="plan-pricing">
            <span class="price-val">₹{{ plan.price }}</span>
            <span class="price-cycle">{{ plan.price === 0 ? '/ forever' : '/ 30 days' }}</span>
          </div>

          <ul class="plan-features-list">
            <li>
              <span class="material-symbols-outlined check-icon">check_circle</span>
              <span><strong>{{ plan.features?.max_profiles || 5 }}</strong> Candidate Bio-Datas Allowed</span>
            </li>
            <li>
              <span class="material-symbols-outlined" [ngClass]="plan.features?.lead_contact_access ? 'check-icon' : 'lock-icon-list'">{{ plan.features?.lead_contact_access ? 'check_circle' : 'cancel' }}</span>
              <span [class.disabled-feat]="!plan.features?.lead_contact_access"><strong>Direct Lead Contact Access</strong> (Phone & Email)</span>
            </li>
            <li>
              <span class="material-symbols-outlined" [ngClass]="plan.features?.who_viewed_candidate ? 'check-icon' : 'lock-icon-list'">{{ plan.features?.who_viewed_candidate ? 'check_circle' : 'cancel' }}</span>
              <span [class.disabled-feat]="!plan.features?.who_viewed_candidate"><strong>Who Viewed Candidate Profile</strong> & Viewer Contacts</span>
            </li>
            <li>
              <span class="material-symbols-outlined" [ngClass]="plan.features?.featured_listings ? 'check-icon' : 'lock-icon-list'">{{ plan.features?.featured_listings ? 'check_circle' : 'cancel' }}</span>
              <span [class.disabled-feat]="!plan.features?.featured_listings">Featured Candidate Listings</span>
            </li>
            <li>
              <span class="material-symbols-outlined" [ngClass]="plan.features?.analytics ? 'check-icon' : 'lock-icon-list'">{{ plan.features?.analytics ? 'check_circle' : 'cancel' }}</span>
              <span [class.disabled-feat]="!plan.features?.analytics">Agency Performance Analytics</span>
            </li>
            <li>
              <span class="material-symbols-outlined" [ngClass]="plan.features?.priority_support ? 'check-icon' : 'lock-icon-list'">{{ plan.features?.priority_support ? 'check_circle' : 'cancel' }}</span>
              <span [class.disabled-feat]="!plan.features?.priority_support">24/7 Priority VIP Support</span>
            </li>
          </ul>

          <div class="plan-cta-area">
            <button class="btn-plan-active" *ngIf="currentBrokerPlan === plan.plan_code" disabled>
              <span class="material-symbols-outlined">verified</span> Active Current Plan
            </button>
            <button class="btn-plan-upgrade" *ngIf="currentBrokerPlan !== plan.plan_code" (click)="onSubscribeBrokerPlan(plan)" [disabled]="subscribingPlan">
              {{ plan.price === 0 ? 'Downgrade to Free' : 'Upgrade Now' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Upload New Candidate -->
  <div class="modal-backdrop" *ngIf="showAddCandidateModal">
    <div class="modal-card modal-lg" style="max-width: 750px; max-height: 92vh; overflow-y: auto;">
      <div class="modal-header">
        <h3>Upload Candidate Bio-Data</h3>
        <button class="btn-close" (click)="closeAddCandidateModal()"><span
            class="material-symbols-outlined">close</span></button>
      </div>

      <!-- Modal Navigation Tabs -->
      <div class="modal-nav-tabs">
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'basic'"
          (click)="activeModalTab = 'basic'">📸 Photo & Basic</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'religion'"
          (click)="activeModalTab = 'religion'">🛕 Religion</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'personal'"
          (click)="activeModalTab = 'personal'">🏃 Personal & Bio</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'professional'"
          (click)="activeModalTab = 'professional'">💼 Career & City</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'family'"
          (click)="activeModalTab = 'family'">👨‍👩‍👧 Family</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'horoscope'"
          (click)="activeModalTab = 'horoscope'">🪐 Horoscope</button>
      </div>

      <div class="modal-body" style="padding: 24px;">
        <!-- TAB 1: Basic & Photo -->
        <div *ngIf="activeModalTab === 'basic'">
          <div
            style="text-align: center; margin-bottom: 24px; padding: 16px; background: #fafafa; border-radius: 12px; border: 1px dashed #ddd;">
            <div *ngIf="newCandidate.photoPreview" style="margin-bottom: 12px;">
              <img [src]="newCandidate.photoPreview"
                style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover; border: 3px solid var(--color-primary, #B01E3E); box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
            </div>
            <div *ngIf="!newCandidate.photoPreview"
              style="width: 80px; height: 80px; border-radius: 50%; background: #eee; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px auto; color: #888;">
              <span class="material-symbols-outlined" style="font-size: 36px;">add_a_photo</span>
            </div>
            <label class="btn-upload-photo"
              style="cursor: pointer; background: var(--color-primary, #B01E3E); color: #fff; padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; display: inline-flex; align-items: center; gap: 6px;">
              <span class="material-symbols-outlined" style="font-size: 16px;">upload</span>
              {{ newCandidate.photoPreview ? 'Change Candidate Photo' : 'Upload Candidate Photo' }}
              <input type="file" (change)="onPhotoSelected($event, false)" accept="image/*" style="display: none;">
            </label>
            <p style="font-size: 12px; color: #888; margin: 6px 0 0 0;">Supported: JPG, PNG (Max 10MB)</p>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>First Name *</label>
              <input type="text" [(ngModel)]="newCandidate.first_name" placeholder="e.g. Priya or Karthik"
                class="form-input" required>
            </div>
            <div class="form-group">
              <label>Last Name / Initial</label>
              <input type="text" [(ngModel)]="newCandidate.last_name" placeholder="e.g. S or Sharma" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Gender *</label>
              <select [(ngModel)]="newCandidate.gender" class="form-input">
                <option value="Male">Male (Groom)</option>
                <option value="Female">Female (Bride)</option>
              </select>
            </div>
            <div class="form-group">
              <label>Date of Birth *</label>
              <app-dob-picker [(ngModel)]="newCandidate.date_of_birth" name="newCandDob" customClass="form-input" [hasError]="isUnderAge(newCandidate.date_of_birth)"></app-dob-picker>
              <small class="text-danger d-block mt-1" *ngIf="newCandidate.date_of_birth && isUnderAge(newCandidate.date_of_birth)" style="color: #dc3545; font-size: 0.8rem;">Candidate must be at least 18 years old.</small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mobile Number (For broker contact)</label>
              <input type="tel" [(ngModel)]="newCandidate.phone" placeholder="9876543210" class="form-input">
            </div>
            <div class="form-group">
              <label>Email Address</label>
              <input type="email" [(ngModel)]="newCandidate.email" placeholder="candidate@example.com"
                class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mother Tongue</label>
              <select [(ngModel)]="newCandidate.mother_lang_id" class="form-input">
                <option value="">Select Mother Tongue</option>
                <option *ngFor="let l of languages" [value]="l._id">{{ l.language_name || l.language_nme || l.lang_name
                  || l.lang_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Marital Status</label>
              <select [(ngModel)]="newCandidate.marital_status" class="form-input">
                <option value="Never Married">Never Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 2: Religion & Community -->
        <div *ngIf="activeModalTab === 'religion'">
          <div class="form-row">
            <div class="form-group">
              <label>Religion *</label>
              <select [(ngModel)]="newCandidate.religion_id" (change)="onReligionChange()" class="form-input">
                <option value="">Select Religion</option>
                <option *ngFor="let r of religions" [value]="r._id">{{ r.religion_name || r.religion_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Caste *</label>
              <select [(ngModel)]="newCandidate.caste_id" (change)="onCasteChange()" class="form-input">
                <option value="">Select Caste</option>
                <option *ngFor="let c of castes" [value]="c._id">{{ c.caste_name || c.caste_nme }}</option>
              </select>
            </div>
          </div>

          <!-- Astrology Note -->
          <div class="form-row" style="margin-top: 12px; margin-bottom: 12px; display: block; width: 100%;">
            <div style="padding: 10px 14px; background-color: #faf6f0; border-left: 3px solid #C5A059; border-radius: 4px;">
              <p style="margin: 0; font-size: 12px; color: #856404; font-style: italic; font-weight: 500; line-height: 1.4;">
                Astrology Details (Optional) – Fill these only if they are relevant to you or your family's preferences.
              </p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Sub-Caste</label>
              <select [(ngModel)]="newCandidate.sub_caste_id" class="form-input">
                <option value="">Select Sub-Caste (or Leave Blank)</option>
                <option *ngFor="let sc of subCastes" [value]="sc._id">{{ sc.subcaste_name || sc.subcaste_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Gothram <span *ngIf="isHindu(newCandidate.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="newCandidate.gothrm_id" class="form-input">
                <option value="">Select Gothram</option>
                <option *ngFor="let g of gothrams" [value]="g._id">{{ g.gothram_name || g.gothram_nme }}</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Dosham / Manglik? <span *ngIf="isHindu(newCandidate.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="newCandidate.dosham" class="form-input">
                <option value="No">No Dosham</option>
                <option value="Yes">Yes (Manglik / Chevvai)</option>
                <option value="Don't Know">Don't Know</option>
              </select>
            </div>
            <div class="form-group">
              <label>Open to other communities?</label>
              <select [(ngModel)]="newCandidate.want_same_community" class="form-input">
                <option [ngValue]="true">No, Same Community Only</option>
                <option [ngValue]="false">Yes, Open to All Communities</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 3: Personal & Physical -->
        <div *ngIf="activeModalTab === 'personal'">
          <div class="form-row">
            <div class="form-group">
              <label>Height (in cm)</label>
              <input type="number" [(ngModel)]="newCandidate.height" placeholder="165" class="form-input">
            </div>
            <div class="form-group">
              <label>Weight (in kg)</label>
              <input type="number" [(ngModel)]="newCandidate.weight" placeholder="60" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Physical Status</label>
              <select [(ngModel)]="newCandidate.physical_status" class="form-input">
                <option value="Normal">Normal</option>
                <option value="Physically Challenged">Physically Challenged</option>
              </select>
            </div>
            <div class="form-group">
              <label>Food Preference</label>
              <select [(ngModel)]="newCandidate.food" class="form-input">
                <option value="Vegetarian">Vegetarian</option>
                <option value="Non-vegetarian">Non-Vegetarian</option>
                <option value="Eggtarian">Eggtarian</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>Body Type</label>
            <select [(ngModel)]="newCandidate.body_type" class="form-input">
              <option value="Average">Average</option>
              <option value="Slim">Slim</option>
              <option value="Athletic">Athletic</option>
              <option value="Heavy">Heavy</option>
            </select>
          </div>

          <div class="form-group">
            <label>About Candidate (Bio & Expectations)</label>
            <textarea [(ngModel)]="newCandidate.about_me" rows="3"
              placeholder="Write a brief introduction about the bride/groom, personality, and expectations..."
              class="form-input" style="height: auto;"></textarea>
          </div>
        </div>

        <!-- TAB 4: Professional & Location -->
        <div *ngIf="activeModalTab === 'professional'">
          <div class="form-row">
            <div class="form-group">
              <label>Highest Education</label>
              <select [(ngModel)]="newCandidate.education_id" class="form-input">
                <option value="">Select Degree / Education</option>
                <option *ngFor="let ed of educations" [value]="ed._id">{{ ed.education_name || ed.education_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>College / Institution (Optional)</label>
              <input type="text" [(ngModel)]="newCandidate.education_detail" placeholder="e.g. BCA at SRM Institute of Science and Technology" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Occupation Category</label>
              <select [(ngModel)]="newCandidate.occupation_id" class="form-input">
                <option value="">Select Occupation Category</option>
                <option *ngFor="let oc of occupations" [value]="oc._id">{{ oc.occupation_name || oc.occupation_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Designation / Job Title (Optional)</label>
              <input type="text" [(ngModel)]="newCandidate.occupation_detail"
                placeholder="e.g. Senior Java Developer at TCS" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Annual Salary / Income Range</label>
              <select [(ngModel)]="newCandidate.income_id" class="form-input">
                <option value="">Select Annual Income</option>
                <option *ngFor="let inc of incomes" [value]="inc._id">{{ inc.income_name || inc.income_nme || inc.income
                  }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Exact Salary / Currency (Optional)</label>
              <input type="text" [(ngModel)]="newCandidate.annual_salary" placeholder="e.g. 12 Lakhs per annum"
                class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Additional Income Source (Optional)</label>
              <select [(ngModel)]="newCandidate.additional_income_source" class="form-input">
                <option value="">Select Source</option>
                <option *ngFor="let src of additionalIncomeSources" [value]="src">{{ src }}</option>
              </select>
            </div>
            <div class="form-group" *ngIf="newCandidate.additional_income_source">
              <label>Additional Annual Income (₹)</label>
              <input type="number" [(ngModel)]="newCandidate.additional_annual_income" placeholder="e.g. 250000" min="1" class="form-input">
            </div>
          </div>
          <div class="form-row" *ngIf="isCustomAddIncome(newCandidate.additional_income_source)">
            <div class="form-group" style="width: 100%;">
              <label>Specify Custom Additional Income Source *</label>
              <input type="text" [value]="(newCandidate.additional_income_source === 'Other (Specify / Type Custom)' || newCandidate.additional_income_source === 'Other') ? '' : newCandidate.additional_income_source" (input)="onCustomCandidateIncomeInput($event, false)" placeholder="Type custom source (e.g. Stock Dividends, Royalty, Pension)..." class="form-input">

            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Residing State *</label>
              <select [(ngModel)]="newCandidate.state" class="form-input">
                <option value="">Select State</option>
                <option *ngFor="let st of states" [value]="st._id">{{ st.name_1 || st.state_name || st.state_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Residing City *</label>
              <select [(ngModel)]="newCandidate.city" class="form-input">
                <option value="">Select City</option>
                <option *ngFor="let ct of cities" [value]="ct._id">{{ ct.city_name || ct.city_nme || ct.name_3 ||
                  ct.name_2 }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 5: Family Background -->
        <div *ngIf="activeModalTab === 'family'">
          <div class="form-row">
            <div class="form-group">
              <label>Family Status</label>
              <select [(ngModel)]="newCandidate.family_status" class="form-input">
                <option value="Middle Class">Middle Class</option>
                <option value="Upper Middle Class">Upper Middle Class</option>
                <option value="High Class">High Class</option>
                <option value="Rich/Affluent">Rich/Affluent</option>
              </select>
            </div>
            <div class="form-group">
              <label>Family Type</label>
              <select [(ngModel)]="newCandidate.family_type" class="form-input">
                <option value="Nuclear">Nuclear Family</option>
                <option value="Joint">Joint Family</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Family Values</label>
              <select [(ngModel)]="newCandidate.family_values" class="form-input">
                <option value="Traditional">Traditional</option>
                <option value="Orthodox">Orthodox</option>
                <option value="Moderate">Moderate</option>
                <option value="Liberal">Liberal</option>
              </select>
            </div>
            <div class="form-group">
              <label>Father's Name</label>
              <input type="text" [(ngModel)]="newCandidate.father_name" placeholder="Father's Name" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mother's Name</label>
              <input type="text" [(ngModel)]="newCandidate.mother_name" placeholder="Mother's Name" class="form-input">
            </div>
            <div class="form-group">
              <label>Siblings</label>
              <div style="display: flex; gap: 8px;">
                <input type="number" [(ngModel)]="newCandidate.no_of_brothers" placeholder="Brothers" class="form-input"
                  min="0">
                <input type="number" [(ngModel)]="newCandidate.no_of_sisters" placeholder="Sisters" class="form-input"
                  min="0">
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 6: Horoscope & Astrology -->
        <div *ngIf="activeModalTab === 'horoscope'">
          <!-- Astrology Note -->
          <div class="form-row" style="margin-bottom: 12px; display: block; width: 100%;">
            <div style="padding: 10px 14px; background-color: #faf6f0; border-left: 3px solid #C5A059; border-radius: 4px;">
              <p style="margin: 0; font-size: 12px; color: #856404; font-style: italic; font-weight: 500; line-height: 1.4;">
                Astrology Details (Optional) – Fill these only if they are relevant to you or your family's preferences.
              </p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Star / Nakshatra <span *ngIf="isHindu(newCandidate.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="newCandidate.natchr_id" class="form-input">
                <option value="">Select Star / Nakshatra</option>
                <option *ngFor="let s of natchras" [value]="s._id">{{ s.natchr_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Raasi / Moon Sign <span *ngIf="isHindu(newCandidate.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="newCandidate.rasi_id" class="form-input">
                <option value="">Select Raasi / Moon Sign</option>
                <option *ngFor="let r of rasis" [value]="r._id">{{ r.rasi_nme || r.rasi_name }}</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Time of Birth</label>
              <input type="time" [(ngModel)]="newCandidate.time_of_birth" class="form-input">
            </div>
            <div class="form-group">
              <label>Horoscope Visibility</label>
              <select [(ngModel)]="newCandidate.horoscopeVisibility" class="form-input">
                <option value="Accepted Matches Only">Accepted Matches Only (Recommended)</option>
                <option value="Everyone">Everyone (Public)</option>
              </select>
            </div>
          </div>

          <div class="form-group" style="margin-top: 16px;">
            <label>Upload Horoscope Chart / PDF (Optional, max 10MB)</label>
            <div *ngIf="!newCandidate.horoscopeFile"
              style="border: 2px dashed #B01E3E; padding: 24px; border-radius: 12px; text-align: center; cursor: pointer; background: #fdf8f9; position: relative;">
              <input type="file" (change)="onHoroscopeSelected($event, false)" accept=".jpg,.jpeg,.png,.pdf"
                style="position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;">
              <span class="material-symbols-outlined" style="font-size: 36px; color: #B01E3E;">auto_awesome</span>
              <p style="margin: 8px 0 0; font-weight: 600; color: #B01E3E;">Click or drag horoscope file (JPG, PNG, PDF)
              </p>
            </div>
            <div *ngIf="newCandidate.horoscopeFile"
              style="padding: 12px; border: 1px solid #ddd; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <span class="material-symbols-outlined" style="color: #B01E3E; font-size: 28px;">description</span>
                <div>
                  <strong style="display: block; font-size: 14px;">{{ newCandidate.horoscopeFile.name }}</strong>
                  <span style="font-size: 12px; color: #666;">{{ (newCandidate.horoscopeFile.size / 1024 /
                    1024).toFixed(2) }} MB</span>
                </div>
              </div>
              <button type="button" (click)="removeHoroscope(false)"
                style="background: none; border: none; color: #d32f2f; cursor: pointer; display: flex; align-items: center;">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <button type="button" class="btn-cancel" (click)="closeAddCandidateModal()"
            [disabled]="creatingCandidate">Cancel</button>
        </div>
        <div style="display: flex; gap: 8px;">
          <button type="button" class="btn-cancel" *ngIf="activeModalTab !== 'basic'" (click)="prevTab()">➔ Prev
            Section</button>
          <button type="button" class="btn-confirm-primary" *ngIf="activeModalTab !== 'horoscope'"
            (click)="nextTab()">Next Section ➔</button>
          <button type="button" class="btn-confirm-primary" *ngIf="activeModalTab === 'horoscope'"
            (click)="submitCandidate()" [disabled]="creatingCandidate || !newCandidate.first_name">
            <span class="material-symbols-outlined spin" *ngIf="creatingCandidate">progress_activity</span>
            {{ creatingCandidate ? 'Uploading...' : 'Upload & Publish Profile' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Request Payout -->
  <div class="modal-backdrop" *ngIf="showPayoutModal">
    <div class="modal-card">
      <div class="modal-header">
        <h3>Request Wallet Payout</h3>
        <button class="btn-close" (click)="closePayoutModal()"><span
            class="material-symbols-outlined">close</span></button>
      </div>
      <div class="modal-body">
        <p>Available wallet balance: <strong style="color: #1e7e48; font-size: 16px;">₹{{ broker?.stats?.wallet_balance
            || 0 }}</strong></p>
        <p>Your funds will be transferred to your configured Bank account / UPI within 24-48 hours.</p>
        <div class="form-group" style="margin-top: 16px;">
          <label>Withdrawal Amount (₹)</label>
          <input type="number" [(ngModel)]="payoutAmount" [max]="broker?.stats?.wallet_balance" min="1"
            class="form-input">
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closePayoutModal()" [disabled]="requestingPayout">Cancel</button>
        <button class="btn-confirm-payout" (click)="submitPayout()" [disabled]="requestingPayout || payoutAmount <= 0">
          {{ requestingPayout ? 'Submitting...' : 'Initiate Payout Transfer' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal: Handover OTP -->
  <div class="modal-backdrop" *ngIf="showOtpModal">
    <div class="modal-card">
      <div class="modal-header">
        <h3>Candidate Handover OTP</h3>
        <button class="btn-close" (click)="closeOtpModal()"><span
            class="material-symbols-outlined">close</span></button>
      </div>
      <div class="modal-body" style="text-align: center; padding: 32px 24px;">
        <span class="material-symbols-outlined"
          style="font-size: 48px; color: var(--color-primary, #B01E3E); margin-bottom: 12px;">lock_reset</span>
        <h4 style="margin: 0 0 8px 0; font-size: 18px;">Handover OTP Generated</h4>
        <p style="color: #666; font-size: 14px; margin-bottom: 24px;">Share this 6-digit verification code with
          <strong>{{ otpProfile?.basic_info?.first_name }}</strong> so they can claim and manage their own profile.</p>

        <div
          style="background: #fdf8f9; border: 2px dashed #B01E3E; padding: 16px; border-radius: 12px; font-size: 32px; font-weight: 700; letter-spacing: 6px; color: #B01E3E; display: inline-block; margin-bottom: 16px;">
          {{ generatedOtp }}
        </div>
        <p style="font-size: 12px; color: #888;">This code expires in 15 minutes.</p>
      </div>
      <div class="modal-footer" style="justify-content: center;">
        <button class="btn-confirm-primary" (click)="closeOtpModal()" style="width: 100%;">Done</button>
      </div>
    </div>
  </div>

  <!-- Modal: Edit Candidate Full Bio-Data -->
  <div class="modal-backdrop" *ngIf="showEditModal">
    <div class="modal-card modal-lg" style="max-width: 750px; max-height: 92vh; overflow-y: auto;">
      <div class="modal-header">
        <h3>Edit Candidate Full Bio-Data</h3>
        <button class="btn-close" (click)="closeEditModal()"><span
            class="material-symbols-outlined">close</span></button>
      </div>

      <!-- Modal Navigation Tabs -->
      <div class="modal-nav-tabs">
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'basic'"
          (click)="activeModalTab = 'basic'">📸 Photo & Basic</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'religion'"
          (click)="activeModalTab = 'religion'">🛕 Religion</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'personal'"
          (click)="activeModalTab = 'personal'">🏃 Personal & Bio</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'professional'"
          (click)="activeModalTab = 'professional'">💼 Career & City</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'family'"
          (click)="activeModalTab = 'family'">👨‍👩‍👧 Family</button>
        <button type="button" class="tab-pill" [class.active]="activeModalTab === 'horoscope'"
          (click)="activeModalTab = 'horoscope'">🪐 Horoscope</button>
      </div>

      <div class="modal-body" style="padding: 24px;">
        <!-- TAB 1: Basic & Photo -->
        <div *ngIf="activeModalTab === 'basic'">
          <div
            style="text-align: center; margin-bottom: 24px; padding: 16px; background: #fafafa; border-radius: 12px; border: 1px dashed #ddd;">
            <div *ngIf="editForm.photoPreview || editingCandidate?.personal_info?.avatar_Id"
              style="margin-bottom: 12px;">
              <img
                [src]="editForm.photoPreview || ('https://files.lambdadigital.co.in/matrimony/' + (editingCandidate?.basic_info?.ory_identity_id || editingCandidate?._id) + '/gallery/avatar/' + editingCandidate?.personal_info?.avatar_Id)"
                style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover; border: 3px solid var(--color-primary, #B01E3E); box-shadow: 0 4px 12px rgba(0,0,0,0.1);"
                onerror="this.style.display='none'">
            </div>
            <div *ngIf="!editForm.photoPreview && !editingCandidate?.personal_info?.avatar_Id"
              style="width: 80px; height: 80px; border-radius: 50%; background: #eee; display: flex; align-items: center; justify-content: center; margin: 0 auto 12px auto; color: #888;">
              <span class="material-symbols-outlined" style="font-size: 36px;">person</span>
            </div>
            <label class="btn-upload-photo"
              style="cursor: pointer; background: var(--color-primary, #B01E3E); color: #fff; padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; display: inline-flex; align-items: center; gap: 6px;">
              <span class="material-symbols-outlined" style="font-size: 16px;">upload</span>
              {{ (editForm.photoPreview || editingCandidate?.personal_info?.avatar_Id) ? 'Change Candidate Photo' :
              'Upload Candidate Photo' }}
              <input type="file" (change)="onPhotoSelected($event, true)" accept="image/*" style="display: none;">
            </label>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>First Name *</label>
              <input type="text" [(ngModel)]="editForm.first_name" class="form-input" required>
            </div>
            <div class="form-group">
              <label>Last Name / Initial</label>
              <input type="text" [(ngModel)]="editForm.last_name" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Gender *</label>
              <select [(ngModel)]="editForm.gender" class="form-input">
                <option value="Male">Male (Groom)</option>
                <option value="Female">Female (Bride)</option>
              </select>
            </div>
            <div class="form-group">
              <label>Date of Birth</label>
              <app-dob-picker [(ngModel)]="editForm.date_of_birth" name="editCandDob" customClass="form-input" [hasError]="editForm.date_of_birth && isUnderAge(editForm.date_of_birth)"></app-dob-picker>
              <small class="text-danger d-block mt-1" *ngIf="editForm.date_of_birth && isUnderAge(editForm.date_of_birth)" style="color: #dc3545; font-size: 0.8rem;">Candidate must be at least 18 years old.</small>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mobile Number</label>
              <input type="tel" [(ngModel)]="editForm.mobile" class="form-input">
            </div>
            <div class="form-group">
              <label>Email Address</label>
              <input type="email" [(ngModel)]="editForm.email" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mother Tongue</label>
              <select [(ngModel)]="editForm.mother_lang_id" class="form-input">
                <option value="">Select Mother Tongue</option>
                <option *ngFor="let l of languages" [value]="l._id">{{ l.language_name || l.language_nme || l.lang_name
                  || l.lang_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Marital Status</label>
              <select [(ngModel)]="editForm.marital_status" class="form-input">
                <option value="Never Married">Never Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 2: Religion & Community -->
        <div *ngIf="activeModalTab === 'religion'">
          <div class="form-row">
            <div class="form-group">
              <label>Religion</label>
              <select [(ngModel)]="editForm.religion_id" (change)="onEditReligionChange()" class="form-input">
                <option value="">Select Religion</option>
                <option *ngFor="let r of religions" [value]="r._id">{{ r.religion_name || r.religion_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Caste</label>
              <select [(ngModel)]="editForm.caste_id" (change)="onEditCasteChange()" class="form-input">
                <option value="">Select Caste</option>
                <option *ngFor="let c of castes" [value]="c._id">{{ c.caste_name || c.caste_nme }}</option>
              </select>
            </div>
          </div>

          <!-- Astrology Note -->
          <div class="form-row" style="margin-top: 12px; margin-bottom: 12px; display: block; width: 100%;">
            <div style="padding: 10px 14px; background-color: #faf6f0; border-left: 3px solid #C5A059; border-radius: 4px;">
              <p style="margin: 0; font-size: 12px; color: #856404; font-style: italic; font-weight: 500; line-height: 1.4;">
                Astrology Details (Optional) – Fill these only if they are relevant to you or your family's preferences.
              </p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Sub-Caste</label>
              <select [(ngModel)]="editForm.sub_caste_id" class="form-input">
                <option value="">Select Sub-Caste</option>
                <option *ngFor="let sc of subCastes" [value]="sc._id">{{ sc.subcaste_name || sc.subcaste_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Gothram <span *ngIf="isHindu(editForm.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="editForm.gothrm_id" class="form-input">
                <option value="">Select Gothram</option>
                <option *ngFor="let g of gothrams" [value]="g._id">{{ g.gothram_name || g.gothram_nme }}</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Dosham / Manglik? <span *ngIf="isHindu(editForm.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="editForm.dosham" class="form-input">
                <option value="No">No Dosham</option>
                <option value="Yes">Yes (Manglik / Chevvai)</option>
                <option value="Don't Know">Don't Know</option>
              </select>
            </div>
            <div class="form-group">
              <label>Open to other communities?</label>
              <select [(ngModel)]="editForm.want_same_community" class="form-input">
                <option [ngValue]="true">No, Same Community Only</option>
                <option [ngValue]="false">Yes, Open to All Communities</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 3: Personal & Physical -->
        <div *ngIf="activeModalTab === 'personal'">
          <div class="form-row">
            <div class="form-group">
              <label>Height (in cm)</label>
              <input type="number" [(ngModel)]="editForm.height" placeholder="165" class="form-input">
            </div>
            <div class="form-group">
              <label>Weight (in kg)</label>
              <input type="number" [(ngModel)]="editForm.weight" placeholder="60" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Physical Status</label>
              <select [(ngModel)]="editForm.physical_status" class="form-input">
                <option value="Normal">Normal</option>
                <option value="Physically Challenged">Physically Challenged</option>
              </select>
            </div>
            <div class="form-group">
              <label>Food Preference</label>
              <select [(ngModel)]="editForm.food" class="form-input">
                <option value="Vegetarian">Vegetarian</option>
                <option value="Non-vegetarian">Non-Vegetarian</option>
                <option value="Eggtarian">Eggtarian</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>Body Type</label>
            <select [(ngModel)]="editForm.body_type" class="form-input">
              <option value="Average">Average</option>
              <option value="Slim">Slim</option>
              <option value="Athletic">Athletic</option>
              <option value="Heavy">Heavy</option>
            </select>
          </div>

          <div class="form-group">
            <label>About Candidate (Bio & Expectations)</label>
            <textarea [(ngModel)]="editForm.about_me" rows="3"
              placeholder="Write a brief introduction about the bride/groom..." class="form-input"
              style="height: auto;"></textarea>
          </div>
        </div>

        <!-- TAB 4: Professional & Location -->
        <div *ngIf="activeModalTab === 'professional'">
          <div class="form-row">
            <div class="form-group">
              <label>Highest Education</label>
              <select [(ngModel)]="editForm.education_id" class="form-input">
                <option value="">Select Degree / Education</option>
                <option *ngFor="let ed of educations" [value]="ed._id">{{ ed.education_name || ed.education_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>College / Institution (Optional)</label>
              <input type="text" [(ngModel)]="editForm.education_detail" placeholder="e.g. BCA at SRM Institute of Science and Technology" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Occupation Category</label>
              <select [(ngModel)]="editForm.occupation_id" class="form-input">
                <option value="">Select Occupation Category</option>
                <option *ngFor="let oc of occupations" [value]="oc._id">{{ oc.occupation_name || oc.occupation_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Designation / Job Title (Optional)</label>
              <input type="text" [(ngModel)]="editForm.occupation_detail" placeholder="e.g. Senior Java Developer at TCS"
                class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Annual Salary / Income Range</label>
              <select [(ngModel)]="editForm.income_id" class="form-input">
                <option value="">Select Annual Income</option>
                <option *ngFor="let inc of incomes" [value]="inc._id">{{ inc.income_name || inc.income_nme || inc.income
                  }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Exact Salary (Optional)</label>
              <input type="text" [(ngModel)]="editForm.annual_salary" placeholder="e.g. 12 Lakhs" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Additional Income Source (Optional)</label>
              <select [(ngModel)]="editForm.additional_income_source" class="form-input">
                <option value="">Select Source</option>
                <option *ngFor="let src of additionalIncomeSources" [value]="src">{{ src }}</option>
              </select>
            </div>
            <div class="form-group" *ngIf="editForm.additional_income_source">
              <label>Additional Annual Income (₹)</label>
              <input type="number" [(ngModel)]="editForm.additional_annual_income" placeholder="e.g. 250000" min="1" class="form-input">
            </div>
          </div>
          <div class="form-row" *ngIf="isCustomAddIncome(editForm.additional_income_source)">
            <div class="form-group" style="width: 100%;">
              <label>Specify Custom Additional Income Source *</label>
              <input type="text" [value]="(editForm.additional_income_source === 'Other (Specify / Type Custom)' || editForm.additional_income_source === 'Other') ? '' : editForm.additional_income_source" (input)="onCustomCandidateIncomeInput($event, true)" placeholder="Type custom source (e.g. Stock Dividends, Royalty, Pension)..." class="form-input">

            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Residing State</label>
              <select [(ngModel)]="editForm.state" class="form-input">
                <option value="">Select State</option>
                <option *ngFor="let st of states" [value]="st._id">{{ st.name_1 || st.state_name || st.state_nme }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Residing City</label>
              <select [(ngModel)]="editForm.city" class="form-input">
                <option value="">Select City</option>
                <option *ngFor="let ct of cities" [value]="ct._id">{{ ct.city_name || ct.city_nme || ct.name_3 ||
                  ct.name_2 }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- TAB 5: Family Background -->
        <div *ngIf="activeModalTab === 'family'">
          <div class="form-row">
            <div class="form-group">
              <label>Family Status</label>
              <select [(ngModel)]="editForm.family_status" class="form-input">
                <option value="Middle Class">Middle Class</option>
                <option value="Upper Middle Class">Upper Middle Class</option>
                <option value="High Class">High Class</option>
                <option value="Rich/Affluent">Rich/Affluent</option>
              </select>
            </div>
            <div class="form-group">
              <label>Family Type</label>
              <select [(ngModel)]="editForm.family_type" class="form-input">
                <option value="Nuclear">Nuclear Family</option>
                <option value="Joint">Joint Family</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Family Values</label>
              <select [(ngModel)]="editForm.family_values" class="form-input">
                <option value="Traditional">Traditional</option>
                <option value="Orthodox">Orthodox</option>
                <option value="Moderate">Moderate</option>
                <option value="Liberal">Liberal</option>
              </select>
            </div>
            <div class="form-group">
              <label>Father's Name</label>
              <input type="text" [(ngModel)]="editForm.father_name" placeholder="Father's Name" class="form-input">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Mother's Name</label>
              <input type="text" [(ngModel)]="editForm.mother_name" placeholder="Mother's Name" class="form-input">
            </div>
            <div class="form-group">
              <label>Siblings</label>
              <div style="display: flex; gap: 8px;">
                <input type="number" [(ngModel)]="editForm.no_of_brothers" placeholder="Brothers" class="form-input"
                  min="0">
                <input type="number" [(ngModel)]="editForm.no_of_sisters" placeholder="Sisters" class="form-input"
                  min="0">
              </div>
            </div>
          </div>
        </div>

        <!-- TAB 6: Horoscope & Astrology -->
        <div *ngIf="activeModalTab === 'horoscope'">
          <!-- Astrology Note -->
          <div class="form-row" style="margin-bottom: 12px; display: block; width: 100%;">
            <div style="padding: 10px 14px; background-color: #faf6f0; border-left: 3px solid #C5A059; border-radius: 4px;">
              <p style="margin: 0; font-size: 12px; color: #856404; font-style: italic; font-weight: 500; line-height: 1.4;">
                Astrology Details (Optional) – Fill these only if they are relevant to you or your family's preferences.
              </p>
            </div>
          </div>

          <div *ngIf="!editForm.horoscopeFile && editForm.existingHoroscopeName"
            style="padding: 12px; border: 1px solid #1e7e48; border-radius: 8px; background: #e8f5e9; display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
            <div style="display: flex; align-items: center; gap: 12px;">
              <span class="material-symbols-outlined" style="color: #1e7e48; font-size: 28px;">verified</span>
              <div>
                <strong style="display: block; font-size: 14px; color: #1e7e48;">Current Horoscope: {{
                  editForm.existingHoroscopeName }}</strong>
                <a [href]="getHoroscopeViewUrl(editingCandidate?._id)" target="_blank"
                  style="font-size: 12px; color: #1e7e48; text-decoration: underline;">View Current Horoscope File</a>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Star / Nakshatra <span *ngIf="isHindu(editForm.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="editForm.natchr_id" class="form-input">
                <option value="">Select Star / Nakshatra</option>
                <option *ngFor="let s of natchras" [value]="s._id">{{ s.natchr_nme }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Raasi / Moon Sign <span *ngIf="isHindu(editForm.religion_id)" style="color: #dc3545;">*</span></label>
              <select [(ngModel)]="editForm.rasi_id" class="form-input">
                <option value="">Select Raasi / Moon Sign</option>
                <option *ngFor="let r of rasis" [value]="r._id">{{ r.rasi_nme || r.rasi_name }}</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Time of Birth</label>
              <input type="time" [(ngModel)]="editForm.time_of_birth" class="form-input">
            </div>
            <div class="form-group">
              <label>Horoscope Visibility</label>
              <select [(ngModel)]="editForm.horoscopeVisibility" class="form-input">
                <option value="Accepted Matches Only">Accepted Matches Only (Recommended)</option>
                <option value="Everyone">Everyone (Public)</option>
              </select>
            </div>
          </div>

          <div class="form-group" style="margin-top: 16px;">
            <label>Upload / Replace Horoscope Chart (Optional, max 10MB)</label>
            <div *ngIf="!editForm.horoscopeFile"
              style="border: 2px dashed #B01E3E; padding: 24px; border-radius: 12px; text-align: center; cursor: pointer; background: #fdf8f9; position: relative;">
              <input type="file" (change)="onHoroscopeSelected($event, true)" accept=".jpg,.jpeg,.png,.pdf"
                style="position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;">
              <span class="material-symbols-outlined" style="font-size: 36px; color: #B01E3E;">cloud_upload</span>
              <p style="margin: 8px 0 0; font-weight: 600; color: #B01E3E;">{{ editForm.existingHoroscopeName ? 'Click
                or drag to replace horoscope file' : 'Click or drag horoscope file (JPG, PNG, PDF)' }}</p>
            </div>
            <div *ngIf="editForm.horoscopeFile"
              style="padding: 12px; border: 1px solid #ddd; border-radius: 8px; background: #fff; display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <span class="material-symbols-outlined" style="color: #B01E3E; font-size: 28px;">description</span>
                <div>
                  <strong style="display: block; font-size: 14px;">{{ editForm.horoscopeFile.name }}</strong>
                  <span style="font-size: 12px; color: #666;">{{ (editForm.horoscopeFile.size / 1024 / 1024).toFixed(2)
                    }} MB</span>
                </div>
              </div>
              <button type="button" (click)="removeHoroscope(true)"
                style="background: none; border: none; color: #d32f2f; cursor: pointer; display: flex; align-items: center;">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <button type="button" class="btn-cancel" (click)="closeEditModal()" [disabled]="savingEdit">Cancel</button>
        </div>
        <div style="display: flex; gap: 8px;">
          <button type="button" class="btn-cancel" *ngIf="activeModalTab !== 'basic'" (click)="prevTab()">➔ Prev
            Section</button>
          <button type="button" class="btn-confirm-primary" *ngIf="activeModalTab !== 'horoscope'"
            (click)="nextTab()">Next Section ➔</button>
          <button type="button" class="btn-confirm-primary" *ngIf="activeModalTab === 'horoscope'"
            (click)="saveCandidateEdit()" [disabled]="savingEdit || !editForm.first_name">
            <span class="material-symbols-outlined spin" *ngIf="savingEdit">progress_activity</span>
            {{ savingEdit ? 'Saving...' : 'Save Full Bio-Data' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Who Viewed Candidate Profile -->
  <div class="modal-backdrop" *ngIf="showViewersModal">
    <div class="modal-card modal-lg" style="max-width: 680px;">
      <div class="modal-header" style="background: #fff8f9; border-bottom: 1px solid #ffe3e8;">
        <div>
          <h3 style="color: #b71c1c; margin: 0; font-size: 18px; display: flex; align-items: center; gap: 8px;">
            <span class="material-symbols-outlined">visibility</span>
            Who Viewed Profile: {{ selectedCandidateForViews?.basic_info?.first_name || selectedCandidateForViews?.name || 'Candidate' }}
          </h3>
          <p style="margin: 4px 0 0 0; font-size: 13px; color: #666;">Real-time visitor tracking and direct contact details of interested members.</p>
        </div>
        <button class="btn-close" (click)="closeCandidateViewersModal()"><span class="material-symbols-outlined">close</span></button>
      </div>

      <div class="modal-body" style="padding: 20px; max-height: 70vh; overflow-y: auto;">
        <div *ngIf="loadingViews" style="text-align: center; padding: 40px 0; color: #888;">
          <span class="material-symbols-outlined spin" style="font-size: 32px; color: #b71c1c;">progress_activity</span>
          <p style="margin-top: 10px;">Loading profile visitors...</p>
        </div>

        <div *ngIf="!loadingViews && candidateViewsData">
          <!-- Exclusive Pro Feature Lock Banner if !can_view_viewers -->
          <div *ngIf="!candidateViewsData.can_view_viewers" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeeba 100%); border: 1px solid #ffdf7e; border-radius: 12px; padding: 18px; margin-bottom: 20px; text-align: center; color: #856404;">
            <span class="material-symbols-outlined" style="font-size: 36px; color: #d39e00; margin-bottom: 6px;">workspace_premium</span>
            <h4 style="margin: 0 0 6px 0; font-size: 16px; color: #6c5100;">⭐ Exclusive Pro Broker Feature</h4>
            <p style="margin: 0 0 14px 0; font-size: 13.5px; line-height: 1.5;">You are currently on the <strong>{{ candidateViewsData.current_plan }}</strong> plan. Exact view identities ("Who seen the candidate's profile") along with direct phone numbers & emails are reserved exclusively for the <strong>Pro Broker (PRO_BROKER)</strong> tier!</p>
            <button class="btn-confirm-primary" style="background: #b71c1c; color: #fff; padding: 8px 20px; border-radius: 6px; font-weight: 600; cursor: pointer; border: none;" (click)="closeCandidateViewersModal(); activeTab = 'plans'">
              Upgrade to Pro Broker Now
            </button>
          </div>

          <!-- Empty State -->
          <div *ngIf="candidateViewsData.views?.length === 0" style="text-align: center; padding: 40px 0; color: #888;">
            <span class="material-symbols-outlined" style="font-size: 40px; color: #ccc;">person_off</span>
            <h4 style="margin: 10px 0 4px 0; color: #555;">No Visitors Recorded Yet</h4>
            <p style="font-size: 13px; margin: 0;">Once platform members browse this candidate's bio-data, their visits will appear here instantly!</p>
          </div>

          <!-- Viewers List -->
          <div *ngIf="candidateViewsData.views?.length > 0" style="display: flex; flex-direction: column; gap: 12px;">
            <div *ngFor="let v of candidateViewsData.views" style="display: flex; align-items: center; justify-content: space-between; padding: 14px; border: 1px solid #eee; border-radius: 10px; background: #fff; transition: all 0.2s;" [style.opacity]="v.is_masked ? '0.85' : '1'">
              <div style="display: flex; align-items: center; gap: 12px;">
                <img [src]="v.viewer_photo || 'assets/default-avatar.png'" style="width: 46px; height: 46px; border-radius: 50%; object-fit: cover; border: 2px solid #ffccd5;" onerror="this.src='assets/default-avatar.png'">
                <div>
                  <div style="display: flex; align-items: center; gap: 6px;">
                    <strong style="font-size: 15px; color: #222;">{{ v.viewer_name }}</strong>
                    <span *ngIf="v.is_masked" style="background: #eee; color: #666; font-size: 10px; padding: 2px 6px; border-radius: 4px; font-weight: 600;">LOCKED</span>
                    <span *ngIf="!v.is_masked" style="background: #e6f4ea; color: #137333; font-size: 10px; padding: 2px 6px; border-radius: 4px; font-weight: 600;">VERIFIED MEMBER</span>
                  </div>
                  <div style="font-size: 12.5px; color: #666; margin-top: 3px;">
                    📍 {{ v.location }} &nbsp;•&nbsp; 💼 {{ v.profession }}
                  </div>
                  <div style="font-size: 11.5px; color: #999; margin-top: 2px;">
                    Visited on {{ v.viewed_at | date:'mediumDate' }} at {{ v.viewed_at | date:'shortTime' }}
                  </div>
                </div>
              </div>

              <!-- Contact Info Right Box -->
              <div style="text-align: right; min-width: 170px;">
                <div *ngIf="!v.is_masked" style="background: #f8f9fa; border: 1px solid #e9ecef; padding: 8px 12px; border-radius: 8px;">
                  <div style="font-size: 13px; font-weight: 600; color: #222; display: flex; align-items: center; justify-content: flex-end; gap: 4px;">
                    <span class="material-symbols-outlined" style="font-size: 14px; color: #28a745;">call</span>
                    <a [href]="'tel:' + v.mobile" style="color: inherit; text-decoration: none;">{{ v.mobile }}</a>
                  </div>
                  <div style="font-size: 11.5px; color: #666; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; max-width: 160px;">
                    ✉️ {{ v.email }}
                  </div>
                </div>

                <div *ngIf="v.is_masked" style="background: #fff3f5; border: 1px solid #ffccd5; padding: 8px 12px; border-radius: 8px; text-align: center;">
                  <span class="material-symbols-outlined" style="font-size: 16px; color: #b71c1c;">lock</span>
                  <div style="font-size: 12px; font-weight: 600; color: #b71c1c;">{{ v.mobile }}</div>
                  <div style="font-size: 10.5px; color: #888;">Upgrade to Pro to view</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 14px 20px; background: #fafafa; border-top: 1px solid #eee;">
        <button type="button" class="btn-cancel" (click)="closeCandidateViewersModal()">Close</button>
      </div>
    </div>
  </div>
</div>